import { watch } from 'vue';
import { flagsState, loadFlags, reportFlagExposure, resolveVariant, trackEvent } from './posthog';

/*
 * Flagi i eventy PostHoga w szablonach PHP (poza Vue).
 *
 * Flaga (klucz zawsze z rejestru feature-flags.json przez zt_feature_flag(), nigdy wpisany ręcznie):
 *   <div data-feature-flag="<?= esc_attr(zt_feature_flag('NAZWA_FLAGI')) ?>">
 *     <div data-variant-content="control">…</div>
 *     <div data-variant-content="test" hidden>…</div>
 *   </div>
 * - Warianty inne niż control renderujemy z atrybutem `hidden`.
 * - Do rozstrzygnięcia wariantu treść jest niewidoczna (src/css/main.pcss; failsafe po 3 s → control).
 * - Po rozstrzygnięciu kontener dostaje data-variant="<wariant>" (do stylowania wariantu w CSS).
 * - Element z data-variant-content nie może mieć klasy ustawiającej display (flex, block…),
 *   bo nadpisuje [hidden] — opakuj wariant w zwykły <div>/<span>.
 *
 * Event:
 *   <a data-track-event="obiekt_akcja" data-track-props='{"klucz":"wartość"}'>
 * - Nazwa wg konwencji z posthog.js (angielski, snake_case, czas przeszły).
 */

export function initPhpFeatureFlags() {
  const allContainers = [...document.querySelectorAll('[data-feature-flag]')];
  // Pusty klucz = nieznana nazwa w zt_feature_flag() → od razu control, bez zapytania o flagę.
  allContainers
    .filter((container) => !container.dataset.featureFlag)
    .forEach((container) => {
      container.dataset.variant = 'control';
    });
  const containers = allContainers.filter((container) => container.dataset.featureFlag);
  if (!containers.length) {
    return;
  }
  const reportedKeys = new Set();

  loadFlags();

  watch(
    () => [flagsState.ready, flagsState.loaded, flagsState.flags],
    ([ready, loaded]) => {
      if (!ready) {
        return;
      }
      containers.forEach(applyVariant);
      if (!loaded) {
        return;
      }
      containers.forEach((container) => {
        const key = container.dataset.featureFlag;
        if (!reportedKeys.has(key)) {
          reportedKeys.add(key);
          reportFlagExposure(key);
        }
      });
    },
    { immediate: true },
  );
}

function applyVariant(container) {
  const contents = [...container.querySelectorAll('[data-variant-content]')]
    .filter((el) => el.closest('[data-feature-flag]') === container);
  let variant = resolveVariant(container.dataset.featureFlag);
  if (!contents.some((el) => el.dataset.variantContent === variant)) {
    variant = 'control';
  }
  contents.forEach((el) => {
    el.hidden = el.dataset.variantContent !== variant;
  });
  container.dataset.variant = variant;
}

export function initDeclarativeTracking() {
  window.addEventListener('click', (event) => {
    const element = event.composedPath()
      .find((el) => el instanceof Element && el.hasAttribute('data-track-event'));
    if (!element) {
      return;
    }
    let properties = {};
    try {
      properties = JSON.parse(element.dataset.trackProps || '{}');
    } catch (e) {}
    trackEvent(element.dataset.trackEvent, properties);
  }, { capture: true });
}
